import { Box, Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ReplayIcon from '@mui/icons-material/Replay';
import { getActiveQuestion, submitAnswer } from './ParticipantDashboardRequests';
import SendIcon from '@mui/icons-material/Send';
import Swal from 'sweetalert2';
import { AtomLoading, CommetLoading, RippleLoading } from '../Loader/Loader';
import Stat from '../assets/stat.jpg';
import { green, orange, red, yellow } from '@mui/material/colors';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
export const ParticipantDashboard = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const user_id = localStorage.getItem('user_id');

    const [question,setQuestion] = useState({})
    const [hasAnswered,setHasAnswered] = useState(false)
    const [score,setScore] = useState(0)
    useEffect(()=>{
        _init();
    },[])
    const _init = async () =>{
        const res = await getActiveQuestion(user_id)
        console.log(res.data)
        setQuestion(res.data.data)
        setScore(res.data.score)
    }
    const reload = () => {
        _init();
    }
    const [answer,setAnswer] = useState('')
    const handleSubmit = async (e) => {
        e.preventDefault();
        try{
            Swal.fire({
                icon:'info',
                title:'Submitting answer',
                text:'Please wait...',
                allowOutsideClick:false,
                allowEscapeKey:false
            })
            Swal.showLoading();
            const res = await submitAnswer({id:user_id,answer:answer,q_id:question.id})
            if(res.data.status === 200){
                setQuestion(res.data.data)
                setScore(res.data.score)
                setAnswer('')
                if(res.data.correct){
                    Swal.fire({
                        icon:'success',
                        title:'Correct !',
                        timer:1500,
                        showConfirmButton:false
                    })
                }else{
                    Swal.fire({
                        icon:'error',
                        title:'Oops... Incorrect !',
                        timer:1500,
                        showConfirmButton:false

                    })
                }
                
            }else if(res.data.status === 400){
                setQuestion(res.data.data)
                setScore(res.data.score)
                setAnswer('')
                Swal.fire({
                    icon:'error',
                    title:res.data.message
                })
            }else{
                Swal.fire({
                    icon:'error',
                    title:res.data.message
                })
            }
        }catch(err){
            Swal.fire({
                icon:'error',
                title:err
            })
        }
        
    }
    return (
        <Box sx={{m:matches?1:2}}>
        <Grid container sx={{p:matches?0:5}}>
            <Grid item xs={12} sx={{display:'flex',gap:2,flexDirection:matches?'column':'row',justifyContent:'space-between',alignItems:'center',textAlign:'center'}}>
                <Typography variant={matches?'h6':'h3'} sx={{display:'flex',flexDirection:matches?'column':'row',color:orange[800],backdropFilter:'blur(10px)'}}>My Score: <strong>{`${score} ${score>1?'points':'point'}`}</strong></Typography>
                <Button variant='contained' startIcon={<ReplayIcon/>} onClick={reload}>Next Question</Button>
            </Grid>
            <Grid item xs={12} sx={{mb:5,mt:5}}>
                {
                    question.question
                    ?
                    <Typography variant='h4' align='center' sx={{color:question.difficulty==='Easy'?green[800]:question.difficulty==='Intermediate'?orange[800]:red[800]}}>{question.difficulty} {matches?<br/>:null}({`${question.point} ${question.point>1?'points':'point'}`})</Typography>
                    :
                    null
                }
                
            </Grid>
            {
                question.question
                ?
                <form onSubmit={handleSubmit} style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                {/* <Grid container item xs={12} sx={{mt:5,pl:matches?5:'20dvw',background:'#fff', borderRadius:'20px',pt:5,pb:5}}> */}
                <Box sx={{background:'#fff',p:5,borderRadius:'20px'}}>
                <Grid container item xs={12}>
                    {/* <Grid item xs={12}>
                        <Typography variant='h4'>{question.question}</Typography>
                    </Grid> */}
                   
                    <Grid item xs={12} sx={{display:'flex'}}>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={answer}
                            onChange={(val)=>setAnswer(val.target.value)}
                            name="radio-buttons-group"
                        >
                            {
                                JSON.parse(question?.choices).map((item)=>{
                                    return (
                                        <FormControlLabel key ={item.key} value={item.key} control={<Radio />} label={`${item.key}. ${item.name}`} required/>
                                    )
                                })
                            }
                        </RadioGroup>

                    </Grid>
                    <Grid item xs={12}>
                            <Button variant='contained' endIcon={<SendIcon/>} type='submit'>Submit</Button>
                    </Grid>
                </Grid>
                </Box>
                </form>
                
                :
                <Grid item xs={12} sx={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                    <Typography variant='h5'>Please wait for the next Question</Typography>
                    <RippleLoading/>
                </Grid>

            }
            
        </Grid>
        </Box>
    )
}